<template>
  <SelectLayout>
    <section class="digitalprev">
      <div>
        <h1>DigitalPrev</h1>
        <label for="digitalprev">Baixe o aplicativo:</label>
      </div>
      <div class="stores">
        <div class="store-card">
          <img src="@/assets/img/digitalprev/android_digitalprev.png" alt="digitalprev" width="180" height="180" />
          <a href="https://play.google.com/store/apps/details?id=br.srv.futuratec&hl=pt_BR" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/img/digitalprev/getongplay.png" alt="baixar na google play" width="120" />
          </a>
        </div>
        <div class="store-card">
          <img src="@/assets/img/digitalprev/ios_digitalprev.png" alt="digitalprev" width="180" height="180" />
          <a href="https://apps.apple.com/br/app/digitalprev/id1626739012" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/img/digitalprev/baixar_appstore.svg" alt="baixar na app store" width="120" />
          </a>
        </div>
      </div>
    </section>
  </SelectLayout>
</template>

<script>
import SelectLayout from '@/components/layout/SelectLayout.vue'

export default {
  name: "DigitalPrev",
  components: { SelectLayout }
}
</script>

<style scoped>
.digitalprev {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.digitalprev h1 {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}

.digitalprev label {
  font-size: 14px;
  color: #ccc;
}

.stores {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
  justify-content: center;
}

.store-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
  padding: 32px;
}

.store-card img:first-child {
  border-radius: 8px;
}
</style>
